import * as React from 'react';

import {Button} from 'shells/button/button';
import {NavButtons, RightFrame, ModalMain} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';

import {appHistory} from '../../../../../history';

import {trackModalPageLoad} from '../track-page-load';

type Props = {
    onClose: () => void;
    currentUrl: string;
};

export function Timeout(props: Props) {
    React.useEffect(() => {
        trackModalPageLoad(props.currentUrl);
    }, [props.currentUrl]);

    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>Hang tight, we’re trying to connect...</ModalHeader>
                <ModalSubheader>
                    We’re doing a quick test to verify the connection to your email. This can take a
                    minute or two, so feel free to close this window and check your email settings
                    page later.
                </ModalSubheader>
                <div className='pad-16 flex align-center justify-center'>
                    <img
                        alt=''
                        style={{width: 280}}
                        src='/include/images/email-drip/email-sent-inbox-unconfigured_2x.png'
                    />
                </div>
            </ModalMain>
            <NavButtons>
                <React.Fragment>
                    {/* We can't just use react-router links here, because we're inside a hashrouter. */}
                    <Button
                        variant='text'
                        onClick={() => appHistory.push('/my-account/email-sending')}
                    >
                        Review your settings
                    </Button>
                    <Button variant='primary' size='big' onClick={props.onClose}>
                        Close
                    </Button>
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
